<!-- A11Y-350: ajustes de accesibilidad -->
<div class="max-size-form">
  <h2 id="modal-error-title" class="sr-only">{{ 'Error.modal_error_title' | translate }}</h2>

  <button
    type="button"
    class="modal__close"
    [attr.aria-label]="'Accessibility.aria_close' | translate"
    #errorActionButton
    (click)="emitHide()"
  >
    <span class="ico-close" aria-hidden="true"></span>
  </button>

  <span class="ico-info-circled modal__icon" aria-hidden="true"></span>

  <div
    class="modal__text"
    [innerHTML]="handleTranslate('Errors.' + error?.errorCode | translate: customerSupport)"
  ></div>

  <button
    type="button"
    class="btn--primary modal__btn modal__btn-primary-focus"
    (click)="emitHide()"
  >
    {{ 'Error.modal_error_button' | translate }}
  </button>
</div>
